<template>
  <div class="news">
<!--    <div class="container">-->
<!--      <code class="code">-->
<!--        {{ JSON.stringify(getPreviewData(urls)) }}-->
<!--      </code>-->
<!--    </div>-->
    <HeroSection theme="blue-gradient">
      <h1 class="text-white">Mortgage <span class="text-warning">News</span> from around the UK</h1>
      <p class="text-white">Display some useful introductory message to the user.</p>
    </HeroSection>
    <div class="container space-2">
      <div class="card-sm-columns card-sm-2-count card-lg-3-count card-lg-3-gap">
        <div v-for="url in urls" :key="url">
          <link-prevue :url="url">
            <template slot-scope="props">
              <div class="card mb-5">
                <img class="card-img-top" :src="props.img" :alt="props.title" />
                <div class="card-body">
                  <h4 class="card-title">{{props.title}}</h4>
                  <p class="card-text w-100">{{props.description}}</p>
                  <a v-bind:href="props.url" class="link">More...</a>
                </div>
              </div>
            </template>
          </link-prevue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LinkPrevue from 'link-prevue'
import {getUrlPreview, getUrlPreviews} from "@/services/UrlPreview";
import HeroSection from "@/components/layout/HeroSection";

export default {
    components: {
      HeroSection,
      LinkPrevue
    },
    
    data() {
      return {
        urls: [
            "https://mol.im/a/8850057",
            "https://www.telegraph.co.uk/investing/shares/forget-tesla-zoom-putting-money-british-challenger/?WT.mc_id=e_DM1297031&WT.tsrc=email&etype=Loy_Dig_Tri_200526_TopStories&utmsource=email&utm_medium=Loy_Dig_Tri_200526_TopStories20201017&utm_campaign=DM1297031",
            "https://www.telegraph.co.uk/politics/2020/10/02/exclusive-boris-johnson-vows-put-generation-buy-housing-ladder/?WT.mc_id=tmgliveapp_iosshare_AwBZPYjBSlj6",
            "https://www.telegraph.co.uk/property/uk/bomad-non-grata-nationwides-cap-gifted-deposits-makes-impossible/?WT.mc_id=tmgliveapp_iosshare_Avttn5BZVBPS",
            "https://www.telegraph.co.uk/personal-banking/mortgages/first-time-buyer-mortgages-trickle-back-much-expensive/?WT.mc_id=tmgliveapp_iosshare_Avtt5sMW6MlC",
            "https://www.telegraph.co.uk/property/uk/coronavirus-has-brought-rental-crisis-could-destroy-hopes-first/?WT.mc_id=tmgliveapp_iosshare_AvYfpG9YQTgP",
            "https://thismon.ee/a/1596759",
            "https://thismon.ee/a/1687576",
            "https://apple.news/ATDY8tVMSTRWTrlZ9GQKWJw",
            "https://www.telegraph.co.uk/property/buy-to-let/buy-to-let-tracker-guide/",
            "https://www.bbc.co.uk/news/business-23234033",
            "https://www.telegraph.co.uk/property/buy/real-reason-cant-buy-first-home-not-high-prices/",
            "https://mol.im/a/7776225"
        ]
      }
    },
    
    methods: {
      getPreviewData(urls) {
        return getUrlPreviews(urls);
      }
    }
  }
</script>
